import React from 'react';

import Actions from './Actions';

const columns = [
  {
    name: 'Topic',
    selector: (row) => row.attributes.topic,
    sortable: true,
    maxWidth: '400px',
  },
  {
    name: 'Start Date',
    selector: (row) => row.attributes.start_date,
    cell: (row) => row.attributes.start_date_formatted,
    sortable: true,
  },
  {
    name: 'Start Time',
    selector: (row) => row.attributes.start_time,
    sortable: true,
  },
  {
    name: 'Time Zone',
    selector: (row) => row.attributes.time_zone_offset,
    sortable: true,
  },
  {
    name: 'Host',
    selector: (row) => row.attributes.host,
    sortable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    width: '130px',
    right: true,
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
